import { useGetTimelogTypes } from '@/api/queries/timelog/useGetTimelogTypes';
import { Select, SelectSizeVariant } from '@payaca/ambrosia';

import { FC } from 'react';
import { useListedTimelogsContext } from './listedTimelogsContext';

export const TypeFilter: FC = () => {
  const { timelogTypes } = useGetTimelogTypes();

  const { input, setFilter } = useListedTimelogsContext();

  const typeIds = input?.timelogTypeIds;

  return (
    <Select
      sizeVariant={SelectSizeVariant.SM}
      options={
        timelogTypes
          ? timelogTypes.map((type) => ({
              label: type.name,
              value: type.id,
            }))
          : []
      }
      placeholder="All types"
      multiple={true}
      value={typeIds || []}
      onChange={(values) => {
        setFilter({
          timelogTypeIds: values,
        });
      }}
      CustomSelected={(selected) => {
        if (selected.selectedOptions.length === 0) {
          return;
        } else if (selected.selectedOptions.length === 1) {
          const type = timelogTypes?.find(
            (t) => t.id === selected.selectedOptions[0].value
          );
          return type ? type.name : '1 type';
        } else {
          return `Type - ${selected.selectedOptions.length} selected`;
        }
      }}
      className="w-[16rem]"
    />
  );
};
